import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

import { translate } from '../../commons/localize';

import { STATUS_CONFIRMED } from '../../commons/utils';

import ButtonCustom from '../ButtonCustom';

const cancellationBttnProps = {
  label: 'cancelarReserva',
  dataTestLabel: 'boton-cancelar-reserva',
  colorClass: 'delete-bttn',
  clickAction: () => {},
  isDisabled: false
};

const valorationBttnProps = {
  label: 'valorate',
  dataTestLabel: 'boton-valorar',
  colorClass: 'valorate-bttn',
  clickAction: () => {},
  isDisabled: false
};

const modificationBttnProps = {
  label: 'modificar',
  dataTestLabel: 'boton-modificar',
  colorClass: 'add-bttn',
  clickAction: () => {},
  isDisabled: true
};

const creationBttnProps = {
  label: 'reservar',
  dataTestLabel: 'boton-reservar',
  colorClass: 'add-bttn',
  clickAction: () => {},
  isDisabled: false
};

const getButton = (buttonProps) => {
  const {
    label,
    dataTestLabel,
    colorClass,
    clickAction,
    isDisabled
  } = buttonProps;

  return (
    <ButtonCustom
      label={translate(label)}
      dataTestLabel={dataTestLabel}
      colorClass={colorClass}
      clickAction={clickAction}
      isDisabled={isDisabled}
    />
  );
};

const valorateFirstForm = (props) => {
  const {
    isConfirmed,
    valorated,
    modified,
    valorationAction,
    modificationAction,
    creationAction
  } = props;

  return (
    <>
      {(valorated)
        ?
          <Col sm="2" className="no-padding-right">
            {(isConfirmed)
              ?
                getButton({
                  ...modificationBttnProps,
                  isDisabled: !modified,
                  clickAction: modificationAction
                })
              :
                getButton({
                  ...creationBttnProps,
                  isDisabled: !modified,
                  clickAction: creationAction
                })
            }
          </Col>
        :
          <Col sm="2" className="no-padding-right">
            {getButton({
              ...valorationBttnProps,
              isDisabled: valorated,
              clickAction: valorationAction
            })}
          </Col>
      }
    </>
  );
};

const allButtonsForm = (props) => {
  const {
    isConfirmed,
    valorated,
    modified,
    valorationAction,
    modificationAction,
    creationAction
  } = props;

  return (
    <>
      <Col sm="2" className="no-padding-right">
        {getButton({
          ...valorationBttnProps,
          isDisabled: valorated,
          clickAction: valorationAction
        })}
      </Col>
      <Col sm="2" className="no-padding-right">
        {(isConfirmed)
          ?
            getButton({
              ...modificationBttnProps,
              isDisabled: !modified,
              clickAction: modificationAction
            })
          :
            getButton({
              ...creationBttnProps,
              isDisabled: !modified,
              clickAction: creationAction
            })
        }
      </Col>
    </>
  );
};

const ButtonsManager = (props) => {
  const {
    status,
    hasToValorate,
    readOnly,
    cancellationAction
  } = props;

  const handleCustomClasses = () => {
    let finalClass = 'buttons-manager__container';

    if (props.isDisabled) {
      finalClass = `${finalClass} dirty-prevent`;
    }

    return finalClass;
  };

  const isConfirmed = (status === STATUS_CONFIRMED);

  return (
    <>
      {(!readOnly) &&
        <Row className={handleCustomClasses()}>
          {isConfirmed &&
            <Col sm="2" className="no-padding-right">
              {getButton({
                ...cancellationBttnProps,
                clickAction: cancellationAction
              })}
            </Col>
          }
          {(hasToValorate)
            ?
              valorateFirstForm({
                ...props,
                isConfirmed
              })
            :
              allButtonsForm({
                ...props,
                isConfirmed
              })
          }
        </Row>
      }
    </>
  );
};

ButtonsManager.propTypes = {
  status: PropTypes.string,
  valorated: PropTypes.bool,
  modified: PropTypes.bool,
  hasToValorate: PropTypes.bool,
  isDisabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  cancellationAction: PropTypes.func,
  valorationAction: PropTypes.func,
  modificationAction: PropTypes.func,
  createAction: PropTypes.func
};

ButtonsManager.defaultProps = {
  status: '',
  valorated: false,
  modified: false,
  hasToValorate: false,
  isDisabled: false,
  readOnly: false,
  cancellationAction: () => {},
  valorationAction: () => {},
  modificationAction: () => {},
  createAction: () => {}
};

export default ButtonsManager;
